import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "nascimento--sprite",
  "use": "nascimento--sprite-usage",
  "viewBox": "0 0 19.5 20.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.5 20.5\" id=\"nascimento--sprite\"><title>Icone Nascimento</title><path class=\"cls-1\" d=\"M13,2v8h8a8,8,0,0,0-8-8m6.32,13.89A8,8,0,0,0,21,11H6.44L5.5,9H2v2H4.22s1.89,4.07,2.12,4.42A3.5,3.5,0,1,0,11.46,19h2.08a3.5,3.5,0,1,0,5.78-3.11M8,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,8,20m9,0a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,17,20Z\" transform=\"translate(-1.75 -1.75)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol